import { Track } from '../types';

interface SongBookProps {
  open: boolean;
  onClose: () => void;
  numberToTrackMap: Record<string, Track>;
  playedNumbers: number[];
}

/** Список всех номеров и привязанных к ним песен. */
export const SongBook = ({
  open,
  onClose,
  numberToTrackMap,
  playedNumbers,
}: SongBookProps) => {
  if (!open) return null;

  const played = new Set(playedNumbers);
  const items = Object.keys(numberToTrackMap)
    .map(Number)
    .sort((a, b) => a - b);

  return (
    <div className="song-book" role="dialog" aria-label="Песни по номерам">
      <div className="song-book-panel">
        <div className="song-book-header">
          <h2>Песни по номерам</h2>
          <button type="button" className="dj-chip" onClick={onClose}>
            Закрыть
          </button>
        </div>
        <ol className="song-book-list">
          {items.map((number) => {
            const track = numberToTrackMap[String(number)];
            return (
              <li
                key={number}
                className={`song-book-item ${played.has(number) ? 'is-played' : ''}`}
              >
                <span className="song-book-num">#{number}</span>
                <span>
                  {track?.artist || '—'} — {track?.title || '—'}
                </span>
              </li>
            );
          })}
        </ol>
      </div>
    </div>
  );
};
